import { ToolComponent } from './types';
import { DefaultTool } from './DefaultTool';
import { AddRandomTool } from './AddRandomTool';
import { GetTimeTool } from './GetTimeTool';
import { RollDiceTool } from './RollDiceTool';
import { ShellExecTool } from './ShellExecTool';
import { ViewFileTool } from './ViewFileTool';
import { SearchTool } from './SearchTool';
import { ListFilesTool } from './ListFilesTool';
import { StrReplaceTool } from './StrReplaceTool';
import { WriteFileTool } from './WriteFileTool';
import { TodosTool } from './TodosTool';
import { IntegrationGuideTool } from './IntegrationGuideTool';
import { WebSearchTool } from './WebSearchTool';
import { ErrorReportsListTool } from './ErrorReportsListTool';
import { ErrorReportsUpdateTool } from './ErrorReportsUpdateTool';

// Registry of tool components
const toolComponents: Record<string, ToolComponent> = {
  'add_random': AddRandomTool,
  'get_time': GetTimeTool,
  'roll_dice': RollDiceTool,
  'shell_exec': ShellExecTool,
  'view_file': ViewFileTool,
  'search': SearchTool,
  'list_files': ListFilesTool,
  'str_replace': StrReplaceTool,
  'write_file': WriteFileTool,
  'todos': TodosTool,
  'web_search': WebSearchTool,
  'error_reports_list': ErrorReportsListTool,
  'error_reports_update': ErrorReportsUpdateTool,
  // 'integration_guide': IntegrationGuideTool,
};

// Function to get the appropriate tool component
export function getToolComponent(toolName: string): ToolComponent {
  return toolComponents[toolName] || DefaultTool;
}

// Export all components for direct use if needed
export { DefaultTool } from './DefaultTool';
export { AddRandomTool } from './AddRandomTool';
export { GetTimeTool } from './GetTimeTool';
export { RollDiceTool } from './RollDiceTool';
export { ShellExecTool } from './ShellExecTool';
export { ViewFileTool } from './ViewFileTool';
export { SearchTool } from './SearchTool';
export { ListFilesTool } from './ListFilesTool';
export { StrReplaceTool } from './StrReplaceTool';
export { WriteFileTool } from './WriteFileTool';
export { TodosTool } from './TodosTool';
export { IntegrationGuideTool } from './IntegrationGuideTool';
export { WebSearchTool } from './WebSearchTool';
export { ErrorReportsListTool } from './ErrorReportsListTool';
export { ErrorReportsUpdateTool } from './ErrorReportsUpdateTool';
export type { ToolComponentProps, ToolComponent } from './types';
